<ion-app>
  <ion-split-pane when="(min-width: 3000px)" contentId="main-content">
    <ion-menu #menu contentId="main-content" type="overlay" [style.display]="(menuService.ShowMenuSubject | async) ? '' : 'none'">
      <ion-content>
        <ion-list class="position-relative">

          <div class="boxUser" (click)="navCtrl.navigateRoot('perfil-usuario')">
            <div class="circleUser">
              <ion-icon name="person-outline"></ion-icon>
            </div>
            <div class="ml-3">
              <span class="small">Usuario</span>
              <p>{{service.NombreCompleto | async}}</p>
            </div>
            
          </div>

          <ion-list-header>Menú</ion-list-header>

          <ng-container *ngFor="let page of menuService.MenuSubject | async">
            <ion-item class="itemMenu " (click)="openPage(page)"  lines="none">
              <div>
                <ion-icon name="{{page.icon}}"></ion-icon>
                <div class="menutitle">{{page.title}}</div>
                <span class="arrowRight">
                  <ion-icon name="chevron-forward"></ion-icon>
                </span>
              </div>
            
            </ion-item>
          </ng-container>
          <span class="smallVersion">Versión {{globales.version}}</span>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
  <div class="loginDialog" *ngIf="service.showLogin | async">
    <div class="login-mask"></div>
    <div class="login-window">
      <button class="login-window-close" type="button" (click)="service.onCancelLogin()"><ion-icon name="close"></ion-icon></button>
      <app-login-control (loggedIn)="service.onLoggedIn()"></app-login-control>
    </div>
  </div>

  <!-- loader -->
  <app-loader></app-loader>
  <!-- fin loader -->

  <ion-modal class="modalCustom modalActualizacion" #mdlChangelog (ionModalDidDismiss)="mdlChangelog.isOpen = false">
    <ng-template>
      <ion-header>
        <ion-title>Aplicación actualizada</ion-title>
        <ion-toolbar >
          <ion-button slot="end" class="btn2 " (click)="mdlChangelog.dismiss()"><ion-icon name="close"></ion-icon></ion-button>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <div class="contentModal">
          <img alt="syncro" src="/assets/synchronize.svg">
          <p class="titleModalContent">La aplicación se ha actualizado a la versión {{globales.version}}</p>
          <div [innerHTML]="changeLog"></div>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-app>
